<ng-content select="[illu]"></ng-content>
<ng-content select="[label]"></ng-content>
<ng-content select="[description]"></ng-content>
<ng-content select="[action]"></ng-content>
<ng-content select="[subActionLabel]"></ng-content>
